import { AppRoutes } from '@constants/app-routes'
import { theme } from '@theme'
import { Link } from '@ui/links/Link'

const baseUrlHexagons =
  '/images/cases/platform-for-improving-diagnostic-accuracy'

export const config = {
  title: 'Results and outcomes',
  text: (
    <>
      Joining the project, Modsen software development experts and QA
      professionals had to meet two key objectives: rapid software development
      and strict accountability to the client to ensure workflow effectiveness
      and 100% deadline compliance.
      <br />
      <br />
      <Link href={AppRoutes.partnership}>Modsen</Link> developers bridged the
      existing expertise gap by employing state-of-the-art tech stack and
      utilizing medicine-specific software development experience to complete
      the following tasks:
    </>
  ),
  sections: [
    {
      id: 1,
      text: 'Development of a large-scale web portal for the collection, management, and analysis of patient data at the diagnosing stage and throughout the entire treatment period.',
      backgroundColor: theme.colors.tretinary,
    },
    {
      id: 2,
      text: 'Integration of components that allowed doctors to access the prognostic analytics and data from several hundreds of thousands of cancer patients.',
      backgroundColor: theme.colors.lightOrange1,
    },
    {
      id: 3,
      text: 'Improvement of the quality of prognostic AI algorithms by adding such variables as age, sex, concomitant chronic diseases, and clinical cancer stage.',
      backgroundColor: theme.colors.whiteOrange,
    },
    {
      id: 4,
      text: 'Incorporation of a real-time patient condition tracking feature.',
      backgroundColor: theme.colors.backLight,
    },
  ],
  hexagons: {
    hexagonLeft: {
      width: 327,
      height: 327,
      src: `${baseUrlHexagons}/hexagonLeft.svg`,
      alt: 'HexagonLeft',
      title: 'HexagonLeft',
    },
    hexagonRight: {
      width: 200,
      height: 200,
      src: `${baseUrlHexagons}/hexagonRight.svg`,
      alt: 'HexagonRight',
      title: 'HexagonRight',
    },
    hexagonLeftMobile: {
      width: 213,
      height: 213,
      src: `${baseUrlHexagons}/hexagonLeftMobile.svg`,
      alt: 'HexagonLeftMobile',
      title: 'HexagonLeftMobile',
    },
    hexagonRightMobile: {
      width: 213,
      height: 213,
      src: `${baseUrlHexagons}/hexagonRightMobile.svg`,
      alt: 'HexagonRightMobile',
      title: 'HexagonRightMobile',
    },
  },
  textBottom:
    'Our team has been continuously working on the enhancement and upscaling of the platform to expand the value and potential it brings to cancer patients across European countries and beyond.',
  cards: [
    {
      id: 1,
      title: '31%',
      subtitle: 'Decline in diagnostic errors ocurrence',
    },
    {
      id: 2,
      title: 'X3%',
      subtitle: 'Early cancer diagnosing cases',
    },
    {
      id: 3,
      title: '50%',
      subtitle: 'Faster medical decision-making',
    },
  ],
}
